export const DATE_LONG_FORMAT   = 'dddd D MMMM YYYY'
export const DATE_SHORT_FORMAT   = 'D MMM YYYY'
export const DATE_STANDARD_FORMAT   = 'YYYY-MM-DD'
